<div class="backdrop" *ngIf="backdrop"></div>


<div class="module-text" [colorPicker]="color" (colorPickerOpen)="setBackdrop(true)"
      [cpPresetColors]="presets" (colorPickerClose)="setBackdrop(false)" [cpOutputFormat]="'hex'"
      [cpAlphaChannel]="'always'" (colorPickerChange)="color = $event"
      [style.background]="color" [style.color]="getTextColor(color)">
  <span>{{placeholder}}</span>
  <mat-icon class="edit-icon">edit</mat-icon>
</div>
